import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "./app";
import "./assets/css/main.css";
import "./assets/css/style.css";

ReactDOM.render(<App />, document.getElementById("root"));
